import { render, staticRenderFns } from "./DefiFTradeConfirmation.vue?vue&type=template&id=7f4fab7e&"
import script from "./DefiFTradeConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiFTradeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DefiFTradeConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports